<template>
  <!-- -->
  <div class="txmap-container">
    <!-- 只显示图标模式 -->
    <template v-if="onlyShowIcon">
      <div class="location-icon-wrapper" @click="handleIconClick">
        <el-tooltip
            effect="dark"
            content="点击获取位置"
            placement="top"
        >
          <!--          <yq-icon name="element-ui_location-information"/>-->
        </el-tooltip>
      </div>
    </template>
    <!-- 地图模式 -->
    <template v-else>
      <div style="z-index: 1;height: 100%;position: relative;">
        <div :id="mapId" style="width: 100%; height: 100%;min-height: 300px"></div>
      </div>
      <div class="option-area" v-if="showGetLocation">
        <!--        <page-button el-type="primary" @click="testClick">-->
        <!--          测试-->
        <!--        </page-button>-->
        <el-input style="width: 240px;margin-right: 10px;" v-model="mapSearchKey" :placeholder="placeHolder"
                  @keydown.enter="searchByKey"/>
        <page-button el-type="primary" @click="searchByKey">搜索</page-button>
        <page-button el-type="primary" :loading="getMarkerFromMap" @click="getMarkerFromMap = true">获取定位
        </page-button>
        <!--      <page-button el-type="primary" @click="testMark">test</page-button>-->
      </div>


      <div class="other-show" v-if="otherShow">
        <slot name="other-show">
        </slot>
      </div>
    </template>

  </div>

</template>

<script>
import PageButton from "@/components/h5/button/PageButton.vue";
import commonApi from "@/api/commonApi";
import {ElNotification} from 'element-plus';
import {h, watch} from 'vue'
import util from "@/util/util";
import TableButton from "@/components/h5/button/TableButton.vue";
import Dictionary from "@/components/h5/Dictionary.vue";

export default {
  emits: ["getLocation", "clickMarker"],
  props: {
    mapId: {default: "",required: true},
    // 地图的高度，不能小于300
    // 定位信息, 使用string
    lat: {default: ""},
    lng: {default: ""},
    address: {default: ""},
    // 是否只显示图标
    onlyShowIcon: {
      type: Boolean,
      default: false
    },
    latLngList: {
      default: []
    },
    showColumn: {default: "address"},
    showGetLocation: {default: true},
    otherShow: {default: false}
  },
  name: "",
  components: {
    Dictionary, TableButton,
    PageButton
  },
  data() {
    return {
      // 查询关键字
      mapSearchKey: "",
      // 地图对象
      map: {},
      // 地图搜索对象
      mapSearch: {},

      // 地址解析对象
      mapGeo: {},
      mapWindowInfo: null,
      mapMarkerLayer: null,
      timeout: "",
      // 点击地图时获取坐标
      getMarkerFromMap: false,
      placeHolder: "请输入查询关键字",
      markerList: [], // 显示在地图上的点
      cityInfo: {}, // 当前城市定位信息
      isLocating: false, // 添加定位状态
    };
  },
  created() {
    if (this.address) {
      this.placeHolder = this.address;
    }
    this.loadTxMap();

  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
  },
  beforeUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (this.mapMarkerLayer) {
      this.mapMarkerLayer.destroy();
    }
    if (this.map) {
      this.map = null;
    }
  },
  methods: {
    testClick() {
      this.addMarkersAndCenter([{lat: 39.909, lng: 116.397}, {lat: 39.908, lng: 116.398}, {lat: 39.907, lng: 116.396}])
    },

    // 添加坐标点并居中显示
    addMarkersAndCenter(list) {
      if (!list || list.length === 0) {
        return;
      }
      let arr = [];
      let minLng = list[0].lng, minLat = list[0].lat, maxLng = list[0].lng, maxLat = list[0].lat;
      for (let i = 0; i < list.length; i++) {
        arr.push(this.createMarker(parseFloat(list[i].lat), parseFloat(list[i].lng), list[i].stockAddress || list[i].address, "markerDefault", list[i]))
        if (list[i].lng < minLng) {
          minLng = list[i].lng;
        }
        if (list[i].lng > maxLng) {
          maxLng = list[i].lng;
        }
        if (list[i].lat < minLat) {
          minLat = list[i].lat;
        }
        if (list[i].lat > maxLat) {
          maxLat = list[i].lat;
        }
      }
      this.addMapMarker(arr);
      // 居中显示
      let bounds = new TMap.LatLngBounds(
          new TMap.LatLng(minLat, minLng),
          new TMap.LatLng(maxLat, maxLng)
      );
      this.map.fitBounds(bounds, 10000);
    },
    // 处理图标点击
    handleIconClick() {
      if (this.isLocating) return;
      this.isLocating = true;

      // 直接使用已经加载的 TMap
      if (typeof TMap === 'undefined') {
        ElNotification({
          title: '定位结果通知',
          message: h('i', {style: 'color: #E6A23C'}, '地图服务未加载'),
        })
        this.isLocating = false;
        return;
      }

      this.getLocationByIP();
    },
    // 加载腾讯地图组件
    loadTxMap() {
      let s1 = document.getElementById("txMapScript")
      if (s1) {
        return;
      }
      // 获取配置的地图KEY
      // 获取配置的地图KEY
      commonApi.findSetting("MINI_MAP_KEY").then(setting => {
        const s = document.createElement('script');
        s.src = `https://map.qq.com/api/gljs?v=1.exp&key=${setting.settingValue}&libraries=service`;
        s.id = "txMapScript";
        document.body.appendChild(s);
      })
    },
    initMap() {
      try {
        if (TMap) {
          console.log("地图加载完成")
        }
      } catch (e) {
        this.timeout = setTimeout(() => {
          this.initMap();
        }, 100);
        return;
      }
      // F5刷新时显示地图有问题
      this.timeout = setTimeout(() => {
        // 如果有定位，显示定位
        if (this.lat && this.lng) {
          this.showMapAndCenter(parseFloat(this.lat), parseFloat(this.lng));
          // 根据坐标，获取城市信息
          this.getMapCityByCoords(parseFloat(this.lat), parseFloat(this.lng));
          // 添加点标记
          this.addMapMarker([this.createMarker(parseFloat(this.lat), parseFloat(this.lng), this.address, "markerCurrent")])
        } else {
          // 没有定位，通过ip获取定位
          new TMap.service.IPLocation().locate().then(res => {
            let {lat, lng} = res.result.location;
            this.cityInfo = res.result.ad_info;
            this.showMapAndCenter(lat, lng);
          });
        }
      }, 300);
    },
    // 获取地图当前的城市
    getMapCityByCoords(lat, lng) {
      this.mapGeo.getAddress({location: new TMap.LatLng(lat, lng)}).then(res => {
        this.cityInfo = res.result.ad_info;
        console.log("获取坐标的定位")
        console.log(this.cityInfo)
      });
    },
    showMapAndCenter(lat, lng) {
      //定义地图中心点坐标
      let center = new TMap.LatLng(lat, lng)
      //定义map变量，调用 TMap.Map() 构造函数创建地图
      this.map = new TMap.Map(document.getElementById(this.mapId), {
        center: center,//设置地图中心点坐标
        zoom: 17.2,   //设置地图缩放级别
        // pitch: 43.5,  //设置俯仰角
        // rotation: 45    //设置地图旋转角度
        viewMode: '2D'
      });
      // 定义地址解析服务对象
      this.mapGeo = new TMap.service.Geocoder();
      // 定义搜索服务对象
      this.mapSearch = new TMap.service.Search();

      if (this.map.fitBounds && this.latLngList.length > 0) {
        this.addMarkersAndCenter(this.latLngList)
      }

      // 添加事件，点击地图获取坐标
      this.map.on("click", evt => {
        if (!this.getMarkerFromMap) {
          // 不获取坐标
          return;
        }
        // 添加点标记
        this.mapClick(evt);
        this.getMarkerFromMap = false;
      })
    },
    // 添加点标记到地图上
    addMapMarker(markerList) {
      // 先缓存起来
      this.markerList = markerList;
      if (this.mapMarkerLayer) {
        this.mapMarkerLayer.destroy();// 删除点标记
        // this.mapMarkerLayer.updateGeometries(markerList);
        // return;
      }
      this.mapMarkerLayer = new TMap.MultiMarker({
        id: 'marker-layer',
        map: this.map,
        geometries: markerList,
        styles: {
          "markerDefault": new TMap.MarkerStyle({
            "width": 32,
            "height": 32,
            "anchor": {x: 16, y: 32},
            "src": 'data:image/png;base64,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'
          }),
          "markerCurrent": new TMap.MarkerStyle({
            "width": 32,
            "height": 32,
            "anchor": {x: 16, y: 32},
            "src": 'data:image/png;base64,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'
          })
        }
      });
      // 添加点击事件
      this.mapMarkerLayer.on("click", (evt) => {
        this.mapMarkerClick(evt);
      });
    },
    // 地图上点的点击事件
    mapMarkerClick(evt) {
      // 信息窗，如果不存在就添加
      console.log(evt)
      if (!this.mapWindowInfo) {
        this.mapWindowInfo = new TMap.InfoWindow({
          map: this.map,
          position: evt.latLng,
          offset: {x: 0, y: -32}, //设置信息窗相对position偏移像素
          enableCustom: true,
        });
      }
      this.$emit("clickMarker", evt.geometry.data)
      this.mapWindowInfo.open();
      this.mapWindowInfo.setPosition(evt.geometry.position);
      this.mapWindowInfo.setContent(evt.geometry.title);
      // 当前点设置为选中，其它非选中
      let arr = [];
      for (let i = 0; i < this.markerList.length; i++) {
        if (this.markerList[i].id === evt.geometry.id) {
          arr.push(this.createMarker(evt.geometry.position.lat, evt.geometry.position.lng, evt.geometry.title, "markerCurrent", evt.geometry.data));
        } else {
          arr.push(this.createMarker(this.markerList[i].position.lat, this.markerList[i].position.lng, this.markerList[i].title, "markerDefault", this.markerList[i].data))
        }
      }
      this.addMapMarker(arr);
      // 逆地址解析
      this.$emit("getLocation", {
        lat: evt.geometry.position.lat,
        lng: evt.geometry.position.lng,
        address: evt.geometry.title,
        adCode: this.cityInfo.adcode
      });
    },
    // 地图上点的点击事件
    mapMarkerClick2(evt) {
      // 信息窗，如果不存在就添加
      if (!this.mapWindowInfo) {
        this.mapWindowInfo = new TMap.InfoWindow({
          map: this.map,
          position: new TMap.LatLng(evt.geometry.position.lat, evt.geometry.position.lng),
          offset: {x: 0, y: -32}, //设置信息窗相对position偏移像素
          enableCustom: true,
        });
      }
      this.$emit("clickMarker", evt.geometry.data)
      this.mapWindowInfo.open();
      this.mapWindowInfo.setPosition(new TMap.LatLng(evt.geometry.position.lat, evt.geometry.position.lng));
      this.mapWindowInfo.setContent(evt.geometry.title);
      // 当前点设置为选中，其它非选中
      let arr = [];
      for (let i = 0; i < this.markerList.length; i++) {
        if (this.markerList[i].data.id === evt.geometry.data.id) {
          arr.push(this.createMarker(evt.geometry.position.lat, evt.geometry.position.lng, evt.geometry.title, "markerCurrent", evt.geometry.data));
        } else {
          arr.push(this.createMarker(this.markerList[i].position.lat, this.markerList[i].position.lng, this.markerList[i].title, "markerDefault", this.markerList[i].data))
        }
      }
      this.addMapMarker(arr);
      // 定位标记
      this.map.setCenter(new TMap.LatLng(evt.latLng.lat, evt.latLng.lng));
      this.map.setZoom(15);
    },
    // 点击地图
    mapClick(evt) {
      // 通过坐标，获取中文地址名称
      this.mapGeo.getAddress({location: evt.latLng}).then(res => {
        this.placeHolder = res.result.formatted_addresses.standard_address;
        this.mapSearchKey = "";
        // 向地图添加一个坐标点
        this.addMapMarker([this.createMarker(evt.latLng.lat, evt.latLng.lng, this.placeHolder, "markerCurrent")]);
        this.$emit("getLocation", {
          lat: res.result.location.lat,
          lng: res.result.location.lng,
          address: res.result.formatted_addresses.standard_address,
          adCode: res.result.ad_info.adcode
        });
      });
    },
    // 通过关键字查询
    searchByKey() {
      if (!this.mapSearchKey) {
        this.$message.error("请输入查询关键字")
        return;
      }
      let code = this.cityInfo.adcode + "";
      // this.mapSearch.searchRectangle({keyword: this.mapSearchKey, bounds: this.map.getBounds()}).then(res => {
      // 按城市搜索，以市为单位
      this.mapSearch.searchRegion({keyword: this.mapSearchKey, cityName: code.substring(0, 4) + "00"}).then(res => {
        let arr = [];
        let lat = 0, lng = 0;
        if (this.lat && this.lng) {
          // 添加一个点
          arr.push(this.createMarker(this.lat, this.lng, this.address, "markerCurrent"));
          lat = this.lat;
          lng = this.lng;
        }
        // 添加查询结果
        for (let i = 0; i < res.data.length; i++) {
          arr.push(this.createMarker(res.data[i].location.lat, res.data[i].location.lng, res.data[i].address));
        }
        if (res.data.length) {
          lat = res.data[0].location.lat;
          lng = res.data[0].location.lng;
        }
        // 把点添加到地图上
        this.addMapMarker(arr);
        // 添加完成后，显示所有点
        if (lat && lng) {
          let center = new TMap.LatLng(lat, lng);
          this.map.setCenter(center);
        }
      });
    },


    createMarker(lat, lng, address, style, data) {
      if (!style) {
        style = "markerDefault";
      }
      return {
        position: new TMap.LatLng(lat, lng),
        title: this.showColumn === 'address' ? address : data[this.showColumn],
        styleId: style,
        data: data
      }
    },
    // 通过IP获取位置
    async getLocationByIP() {
      // 创建地理位置服务实例
      // this.mapGeo = new TMap.service.Geocoder({
      //   key: 'RX7BZ-7WHW3-HZ43U-OM6UL-CAEZ7-QVFG3' // 如果需要的话添加 key
      // });
      let user = await util.getUserInfo();
      if (user.getMaxUseMap && Number(user.getMaxUseMap) >= 5) {
        ElNotification({
          title: '定位结果通知',
          message: h('i', {style: 'color: #F56C6C'}, '已达本次登录调用上限！'),
        })
        this.isLocating = false;
        return;
      }

      new TMap.service.IPLocation().locate().then(res => {
        let {lat, lng} = res.result.location;
        this.isLocating = false;
        ElNotification({
          title: '定位结果通知',
          message: h('i', {style: 'color: #67C23A'}, '定位获取成功，天气信息已更新...'),
        })
        user.getMaxUseMap = Number(user.getMaxUseMap ? user.getMaxUseMap : 0) + 1;
        util.setUserInfo(user);
        this.$emit("getLocation", {lat: lat, lng: lng});
      }).catch(error => {
        ElNotification({
          title: '定位结果通知',
          message: h('i', {style: 'color: #F56C6C'}, error.message),
        })
        this.isLocating = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.txmap-container {
  position: relative;
  height: 100%;

  .option-area {
    position: absolute;
    left: 10px;
    top: 10px;
    background: #FFF;
    padding: 10px;
    z-index: 2;
    white-space: nowrap;
  }
}

.other-show {
  width: 325px;
  height: 500px;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 2000;
  position: absolute;
  top: 100px;
  left: 10px;
}
</style>